import React, { useEffect, useRef, useLayoutEffect } from "react";
import star from "./../assets/rounded_star.svg";
import logo from "./../assets/logomark.svg";
import { Col, Row, Container } from "react-bootstrap";
import { Image as CloudImage } from "cloudinary-react";
import { useInView } from "react-intersection-observer";
import Tilt from "react-parallax-tilt";
import { RiTeamLine } from "react-icons/ri";
import { CgCommunity } from "react-icons/cg";
import { useLocation, NavLink } from "react-router-dom";
import Contact from "../components/Contact";
import { HashLink } from "react-router-hash-link";
import { withRouter } from "react-router-dom";

export default function Home() {
  const location = useLocation();
  // custom hooks
  const contactRef = useRef();
  const [inViewRef, inView] = useInView({ threshold: 0.2 });
  // refs
  const videoRef = useRef(null);
  const logoRef = useRef(null);
  useEffect(() => {
    if (inView) {
      logoRef.current.style.transition = "2s all";
      logoRef.current.style.opacity = "1";
      videoRef.current.play();
    } else {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;

      logoRef.current.style.transition = "none";
      logoRef.current.style.opacity = "0";
    }
  }, [inView]); //to control video playback
  useLayoutEffect(() => {
    if (location.hash === "") window.scrollTo(0, 0);
    else if (location.hash === "#contact") {
      setTimeout(function () {
        const { offsetTop } = contactRef?.current;
        window.scrollTo(0, offsetTop);
      }, 400);
    }
  }, [location, contactRef.current]);
  return (
    <>
      <div className="navbar-overlayfix">
        <div className="back zi3">
          <img src={star} className="abs-star-1" alt="star" />
          <img src={star} className="abs-star-2" alt="star" />
          <img src={star} className="abs-star-3" alt="star" />
          <img src={star} className="abs-star-4" alt="star" />
          <img src={star} className="abs-star-5" alt="star" />
          <img src={star} className="abs-star-6" alt="star" />
        </div>
        <Container
          fluid
          className=" d-flex h-100vh align-items-center justify-content-center  bg-brand"
        >
          <video
            muted
            autoPlay
            loop
            playsInline
            className=" videobg "
            src="https://res.cloudinary.com/zerko/video/upload/v1638301230/final_61a67b64ba729f00e85b8374_84286_mv6qed.mp4"
          ></video>
          <section
            ref={inViewRef}
            className="  mx-auto my-auto d-flex flex-column justify-content-center align-items-center  w-100  "
          >
            <img
              src={logo}
              alt="zerko logo brand"
              className="logo_home"
              ref={logoRef}
            />

            <video
              muted
              autoPlay
              playsInline
              className=" videofix zi1"
              src="https://res.cloudinary.com/zerko/video/upload/v1637477520/intro1_1_1_gfdlti.mp4"
              ref={videoRef}
              alt="Zerko Intro video"
            ></video>
            <HashLink to="/#description" className="btn-scroll zi3">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="24" cy="24" r="23.5" stroke="#F3F3F3" />
                <path
                  d="M12 20L24 32L36 20"
                  stroke="#F3F3F3"
                  strokeWidth="4"
                  strokeLinecap="square"
                />
              </svg>
            </HashLink>
          </section>
        </Container>
      </div>
      <div className="fakediv">
        <video
          muted
          autoPlay
          loop
          playsInline
          className=" videobg "
          src="https://res.cloudinary.com/zerko/video/upload/v1638301230/final_61a67b64ba729f00e85b8374_84286_mv6qed.mp4"
        ></video>
      </div>

      {/* description / details */}
      <Container
        id="description"
        fluid
        className="py-3 bg-brandtext position-relative"
      >
        {/* <Row className="mt-5">
          <Col xs={12} className="mb-0 mb-md-5 px-3 px-md-5">
            <section
              className="h-100 p-4  text-wrap d-flex flex-column align-items-center px-3 "
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <h2 className="my-5 display-3 fw-bold text-wrap text-center">
                What is Zerko?
              </h2>
              <p className="display-6 fs-3 pt-2  fw-normal text-center mb-5">
                Zerko is an esports organization and multi-media marketing
                agency with a focus on members personal growth.
              </p>
            </section>
          </Col>
        </Row> */}
        <Row
          className="py-5 px-3 px-md-5"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <Col
            md={7}
            className="d-flex flex-column justify-content-center align-items-center order-2 order-md-1"
          >
            <h2 className="display-4 mt-4 fw-normal  text-wrap text-center d-flex justify-content-center align-items-center flex-column">
              Who We Are
            </h2>
            <img
              src="https://res.cloudinary.com/zerko/image/upload/v1639471495/astronauts_v2_2_onn2m8.webp"
              className=" img-fluid dropshadow"
              alt="astronaut with flag"
            />
            <p className="text-center mt-2 fs-5 px-0 px-md-2">
              Zerko is an esports organization and marketing agency that was
              founded on simple characteristics- personal growth, friendship,
              content creation, and competitiveness. With the name “Zerko”
              deriving from the words berserk and arko which means excited and
              bright as a star, we began the brand Zerko to be the brightest and
              most ambitious organization in the community.
            </p>
          </Col>
          <Col md={5} className=" my-auto order-1 order-md-2">
            <Tilt glareEnable glareMaxOpacity={0.25}>
              <img
                src="https://res.cloudinary.com/zerko/image/upload/v1662314687/website_bg_oewt8o_ha1izm.webp"
                alt=""
                className="img-fluid rounded-3 "
              />
            </Tilt>
          </Col>
        </Row>
        <Row className="py-5 px-3 px-md-5 bg-brand">
          <Col
            md={5}
            data-aos="fade-up"
            data-aos-duration="600"
            className="d-flex flex-column justify-content-center align-items-center order-1 order-md-1"
          >
            <Tilt glareEnable glareMaxOpacity={0.25}>
              <img
                src="https://res.cloudinary.com/zerko/image/upload/v1638475038/visionblank_cn0kyi.webp"
                alt=""
                className="img-fluid rounded-3 "
              />
            </Tilt>
          </Col>
          <Col
            md={7}
            className="d-flex flex-column justify-content-center align-items-center order-2 order-md-2"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <h2 className="display-4 mt-4 fw-normal  text-wrap text-center d-flex justify-content-center align-items-center flex-column text-light">
              Our Vision
            </h2>
            <img
              src="https://res.cloudinary.com/zerko/image/upload/v1639471652/astronaut_helmet_2_rrvsov.webp"
              className=" img-fluid dropshadow"
              alt="astronaut's helmet"
            />
            <p className="text-center mt-2 fs-5 px-0 px-md-2 text-light ">
              Zerko's vision is to be set apart by our professionalism in
              management as well as execution of content by analyzing each
              design, video, and thumbnail while always putting the members
              first.
            </p>
          </Col>
        </Row>
        <Row className="py-5 px-3 px-md-5">
          <Col
            data-aos="fade-up"
            data-aos-duration="600"
            md={7}
            className="d-flex flex-column justify-content-center align-items-center order-2 order-md-1"
          >
            <h2 className="display-4 mt-4 fw-normal  text-wrap text-center d-flex justify-content-center align-items-center flex-column">
              Our Mission
            </h2>
            {/* */}
            <img
              src="https://res.cloudinary.com/zerko/image/upload/v1639077506/astronautwer_plp4t1.webp"
              className=" img-fluid dropshadow"
              alt="astronaut with flag"
            />
            <p className="text-center mt-2 fs-5 px-0 px-md-2">
              Zerko seeks to maintain a positive attitude towards keeping the
              community first and always making decisions that will better the
              esports community and world more positively.
            </p>
          </Col>
          <Col
            md={5}
            className=" my-auto order-1 order-md-2"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <Tilt glareEnable glareMaxOpacity={0.25}>
              <img
                src="https://res.cloudinary.com/zerko/image/upload/v1639073149/Render3pst_sisurm.webp"
                alt=""
                className="img-fluid rounded-3 "
              />
            </Tilt>
          </Col>
        </Row>
      </Container>

      {/* <div className="about_outer">
        <span className="      about_section   ">
          <video
            autoPlay
            loop
            muted
            playsInline
            controls={false}
            src="https://res.cloudinary.com/zerko/video/upload/v1648714428/zerko_1_yb5fet.mp4"
            className="  whobg  "
          />
        </span>
      </div> */}
      {/* <div className="w-100  d-flex  gap-5  justify-content-center align-items-center bgv py-5">
        <NavLink
          to="/team"
          className="my-3  showtm display-5 fs-3 d-flex flex-column flex-sm-row justify-content-center gap-4 align-items-center"
        >
          <RiTeamLine size={30} />
          <span className="px-2 ">Team</span>
        </NavLink>
        <NavLink
          to="/community"
          className="my-3  showtm display-5 fs-3 d-flex flex-column flex-sm-row  justify-content-center gap-4 align-items-center"
        >
          <CgCommunity size={30} />
          <span className="px-2 ">Community</span>
        </NavLink>
      </div> */}
      {/* Contact Section */}
      <span id="contact" ref={contactRef}></span>
      <div>
        <Contact />
      </div>

      <Container
        fluid
        className=" showcase d-flex justify-content-center py-5 px-5 border-bottom"
      >
        <div
          className="d-flex flex-column  justify-content-center align-items-center"
          style={{ gap: "1rem" }}
        >
          <h3 className=" fs-6 font-bold" style={{ color: "#aaa" }}>
            Our Sponsors
          </h3>
          <a
            href="https://www.lumiastream.com"
            target="_blank"
            rel="noreferrer"
            className="w-50 text-center my-auto mx-3 "
          >
            <CloudImage
              cloudName="zerko"
              publicId="lumia_final_gray_ek5d74"
              width="300"
              className="img-fluid"
              alt="lumia.gg logo"
            />
          </a>
        </div>
      </Container>
    </>
  );
}
